interface IconProps {
  fillColor: string
}

export const DeviceSwitchedIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59.9999 34.6666C60.7363 34.6666 61.3333 34.0697 61.3333 33.3333C61.3333 32.5969 60.7363 31.9999 59.9999 31.9999C59.2635 31.9999 58.6666 32.5969 58.6666 33.3333C58.6666 34.0697 59.2635 34.6666 59.9999 34.6666Z"
          fill={fillColor}
        />
        <path
          d="M53.5331 88C53.5331 87.3741 54.0405 86.8666 54.6665 86.8666H65.3331C65.959 86.8666 66.4665 87.3741 66.4665 88C66.4665 88.6259 65.959 89.1333 65.3331 89.1333H54.6665C54.0405 89.1333 53.5331 88.6259 53.5331 88Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.1998 87.9999C40.1998 90.835 42.4981 93.1332 45.3331 93.1332H74.6665C77.5015 93.1332 79.7998 90.835 79.7998 87.9999V31.9999C79.7998 29.1648 77.5015 26.8666 74.6665 26.8666H45.3331C42.4981 26.8666 40.1998 29.1648 40.1998 31.9999L40.1998 46.8666H32.3331C28.2094 46.8666 24.8665 50.2096 24.8665 54.3333C24.8665 58.457 28.2094 61.8 32.3331 61.8H40.1998L40.1998 87.9999ZM42.4665 61.8H61.2637L56.5317 66.5319C56.0891 66.9745 56.0891 67.6921 56.5317 68.1347C56.9743 68.5773 57.6919 68.5773 58.1345 68.1347L65.6026 60.6666L58.1345 53.1986C57.6919 52.756 56.9743 52.756 56.5317 53.1986C56.0891 53.6412 56.0891 54.3588 56.5317 54.8014L61.2637 59.5333H42.4665L42.4665 48L42.4665 31.9999C42.4665 30.4167 43.7499 29.1332 45.3331 29.1332L74.6665 29.1332C76.2497 29.1332 77.5331 30.4167 77.5331 31.9999V87.9999C77.5331 89.5831 76.2497 90.8666 74.6665 90.8666H45.3331C43.7499 90.8666 42.4665 89.5831 42.4665 87.9999L42.4665 61.8ZM40.1998 59.5333V49.1333H32.3331C29.4612 49.1333 27.1331 51.4614 27.1331 54.3333C27.1331 57.2052 29.4612 59.5333 32.3331 59.5333H40.1998Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
